import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { GetResponse } from "@/api/menu-category-preview/response";
import * as MenuCategoryPreviewAPI from "@/api/menu-category-preview";
import { isSuccess } from "@/api/response";
import { GetRequest } from "@/api/menu-category-preview/request";

const MODULE_NAME = "menu-category-preview/get";

/**
 * メニューカテゴリープレビュー取得API（/preview-menu-category）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getResponse: GetResponse = {} as GetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getPreviewUrl() {
    if (this.getResponse.results) {
      return this.getResponse.results.previewUrl;
    } else {
      return "";
    }
  }

  // MutationActions
  @MutationAction
  async get(getRequest: GetRequest) {
    const getResponse = await MenuCategoryPreviewAPI.get(getRequest);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as GetResponse
    };
  }
}

export default getModule(Get);
